import {defineAsyncComponent} from 'vue'

export const AppComponents = {
    'script-blank-page': defineAsyncComponent(() => import('./BlankPage.vue')),
}
